import React, { Component } from 'react';
import { Box, Paper, Chip, Avatar, Card, CardContent, CardActions, Drawer, Grid, Typography, Button } from "@mui/material";
import { Apps, Add, EditOutlined, CheckCircle, Cancel } from "@mui/icons-material";
import EditAppProfile from './EditAppProfile';
import Api from "../../customlib/Api";
import axios from "axios";

// Palet warna aksen berbeda untuk tiap kartu profile, dipakai berputar
// mengikuti banyaknya app profile yang dikembalikan API.
const CARD_COLORS = [
    { accent: "#1565c0", bg: "#e3f2fd" },
    { accent: "#ad1457", bg: "#fce4ec" },
    { accent: "#ef6c00", bg: "#fff3e0" },
    { accent: "#2e7d32", bg: "#e8f5e9" },
    { accent: "#5e35b1", bg: "#ede7f6" },
    { accent: "#00838f", bg: "#e0f7fa" },
    { accent: "#c2185b", bg: "#fce4ec" },
    { accent: "#00695c", bg: "#e0f2f1" },
    { accent: "#6d4c41", bg: "#efebe9" },
    { accent: "#7b1fa2", bg: "#f3e5f5" },
];

class AppProfile extends Component {
    state = { 
        bottom: false,
        appProfiles: [],
        selectedAppProfile: {}
    }

    toggleDrawer = (anchor, open) => (event) => {
        console.log("TOGGLE", anchor, open);
        this.setState({ ...this.state, [anchor]: open });
    };

    loadAppProfile = () => {
        axios
        .post(Api.listAppProfile(), {}, Api.getRequestHeaderNoAuthNew())
        .then((response) => {
            console.log(response);
            this.setState({appProfiles: response.data.data});
        })
        .catch((error) => {
            // this.setState({isSaving: false, message: message, isError: true});
            console.error("There was an error!", error);
        });
    }

    componentDidMount(){
        this.loadAppProfile();
    }

    render() {
        const { appProfiles } = this.state;

        return (
            <Box sx={{ p: 0 }}>
                <Paper
                    sx={{
                        borderRadius: "12px",
                        p: 2.5,
                        mb: 2.5,
                        background: "linear-gradient(135deg, #1565c0 0%, #5e35b1 100%)",
                        color: "#fff",
                        boxShadow: "0 6px 18px rgba(21,101,192,0.25)",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1.5 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{ bgcolor: "rgba(255,255,255,0.18)", borderRadius: "10px", p: 1, display: "flex" }}>
                                <Apps sx={{ fontSize: 26 }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" fontWeight={700}>App Profiles</Typography>
                                <Typography variant="caption" sx={{ opacity: 0.85 }}>{appProfiles.length} profile terdaftar</Typography>
                            </Box>
                        </Box>
                        <Button
                            variant="contained"
                            startIcon={<Add />}
                            onClick={this.toggleDrawer('bottom', true)}
                            sx={{
                                textTransform: "none",
                                borderRadius: "8px",
                                bgcolor: "#fff",
                                color: "#1565c0",
                                fontWeight: 700,
                                "&:hover": { bgcolor: "#f0f2f5" },
                            }}
                        >
                            Tambah Profile
                        </Button>
                    </Box>
                </Paper>

                <Box sx={{ borderRadius: "10px", p: 0 }}>

                    {appProfiles.length === 0 ? (
                        <Box sx={{ textAlign: "center", py: 5 }}>
                            <Typography variant="body2" color="text.secondary">Belum ada app profile.</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                            {appProfiles.map((profile, index) => {
                                const palette = CARD_COLORS[index % CARD_COLORS.length];
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={profile._id}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                borderRadius: "10px",
                                                borderTop: `4px solid ${palette.accent}`,
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                    boxShadow: `0 6px 16px ${palette.accent}33`,
                                                    borderColor: palette.accent,
                                                },
                                            }}
                                        >
                                            <CardContent sx={{ flexGrow: 1, bgcolor: palette.bg }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                                                    <Avatar sx={{ bgcolor: palette.accent, fontWeight: 700 }}>
                                                        {profile.label?.charAt(0)?.toUpperCase() || "?"}
                                                    </Avatar>
                                                    <Typography variant="subtitle1" fontWeight={700} noWrap sx={{ color: palette.accent }}>
                                                        {profile.label}
                                                    </Typography>
                                                </Box>
                                                <Chip
                                                    icon={profile.enabled ? <CheckCircle sx={{ fontSize: 16 }} /> : <Cancel sx={{ fontSize: 16 }} />}
                                                    label={profile.enabled ? "Aplikasi ON" : "Aplikasi OFF"}
                                                    color={profile.enabled ? "success" : "error"}
                                                    size="small"
                                                    sx={{ fontWeight: 600 }}
                                                />
                                            </CardContent>
                                            <CardActions sx={{ px: 2, py: 1.5 }}>
                                                <Button
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    startIcon={<EditOutlined sx={{ fontSize: 16 }} />}
                                                    sx={{
                                                        textTransform: "none",
                                                        borderRadius: "8px",
                                                        color: palette.accent,
                                                        borderColor: palette.accent,
                                                        "&:hover": {
                                                            borderColor: palette.accent,
                                                            bgcolor: palette.bg,
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        this.setState({ bottom: true, selectedAppProfile: profile });
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                </Box>

                <Drawer
                    anchor="bottom"
                    open={this.state.bottom}
                    onClose={this.toggleDrawer('bottom', false)}
                    PaperProps={{ sx: { maxHeight: "92vh" } }}
                >
                    <EditAppProfile data={this.state.selectedAppProfile} onClose={this.toggleDrawer('bottom', false)} />
                </Drawer>
            </Box>
         );
    }
}
 
export default AppProfile;